define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'jump'],
    function ($, transit, modernizr, container, preloader, jumpFactory) {

        return (function () {

            const name = 'module-quiz';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {

            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                currentQuizOpened: null,
                currentQuizIndex: null,
                anim: 0
            };

            view.startup = function () {

            };

            view.bind = function () {
                $(view.publicVars.cssId.quizListItemCls).click(function () {
                    const id = parseInt(container.getData($(this)[0], 'id'));
                    const index = parseInt(container.getData($(this)[0], 'index'));
                    const embedBy = container.getData($(this)[0], 'embed.by');
                    const game = container.getData($(this)[0], 'game');
                    const question = container.getData($(this)[0], 'question');

                    if(view.privateVars.anim === 0) {
                        view.privateVars.anim = 1;
                        if(view.privateVars.currentQuizOpened === id) {
                            view.methods.closeQuizzes();
                        } else {

                            let currentScrollTop = false;

                            if(index > view.privateVars.currentQuizIndex && view.privateVars.currentQuizIndex !== null) {
                                currentScrollTop = $(window).scrollTop()
                                    - $(view.publicVars.cssId.quizListEmbedId + view.privateVars.currentQuizOpened).outerHeight();
                            }

                            container.trackInteraction('show quiz open click', {
                                'subsection': 'series|quiz',
                                'contenttype': 'quiz',
                                'contenttitle': question.toLowerCase().replace(/"/g, "'")
                            });

                            view.methods.closeQuizzes();
                            view.methods.handleItemOpen(id, index, embedBy, game, currentScrollTop);
                        }
                    }
                });
            };

            view.methods = {

                closeQuizzes: () => {
                    $(view.publicVars.cssId.quizListEmbedFrameCls).html('');
                    $('.' + view.publicVars.cssId.quizListEmbedId.substr(1)).css({ display: 'none', visibility: 'hidden', opacity: '0'});
                    view.privateVars.currentQuizOpened = null;
                    view.privateVars.currentQuizIndex = null;
                    view.privateVars.anim = 0;

                    $(view.publicVars.cssId.quizDataArrowCls + '' + view.publicVars.cssId.isUpCls).css({ display: 'none'});
                    $(view.publicVars.cssId.quizDataArrowCls + '' + view.publicVars.cssId.isDownCls).css({ display: 'block'});

                    $(view.publicVars.cssId.quizListItemCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                },

                handleItemOpen: (id, index, embedBy, game, currentScrollTop) => {

                    if(currentScrollTop !== false) {
                        $(window).scrollTop(currentScrollTop);
                    }

                    view.privateVars.currentQuizOpened = id;
                    view.privateVars.currentQuizIndex = index;

                    $(view.publicVars.cssId.quizListItemCls + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(view.publicVars.cssId.quizListEmbedId + id + ' ' + view.publicVars.cssId.quizListEmbedFrameCls).html('');
                    $(view.publicVars.cssId.playbuzzSdkId).remove();

                    $(view.publicVars.cssId.quizListItemCls + id + ' '
                        + view.publicVars.cssId.quizDataArrowCls + '' + view.publicVars.cssId.isUpCls).css({ display: 'block'});
                    $(view.publicVars.cssId.quizListItemCls + id + ' '
                        + view.publicVars.cssId.quizDataArrowCls + '' + view.publicVars.cssId.isDownCls).css({ display: 'none'});

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    let submenuHeight = $(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).outerHeight() -
                        parseInt($(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).css('bottom')) - 30;

                    if($(view.publicVars.cssId.headerSeriesSubmenuCls).css('display') === 'none') {
                        submenuHeight = 2;
                    }

                    $(view.publicVars.cssId.quizListEmbedId + id).css({ display: 'block', visibility: 'visible', opacity: '1'});

                    $(view.publicVars.cssId.quizListEmbedId + id).css({
                        height: 0, padding: 0
                    });

                    $(view.publicVars.cssId.quizListEmbedId + id).transit({
                        height: '300px', padding: '10px'
                    }, 300, () => {

                        $(view.publicVars.cssId.quizLoaderId + id).css({ display: 'block', opacity: 0});

                        $(view.publicVars.cssId.quizLoaderId + id).transit({ opacity: 1 });

                        jump.centerTo(view.publicVars.cssId.quizLoaderId + id, () => {

                            $(view.publicVars.cssId.quizListEmbedId + id + ' ' + view.publicVars.cssId.quizListEmbedFrameCls).css({
                                display: 'none'
                            });

                            $(view.publicVars.cssId.quizListEmbedId + id + ' ' + view.publicVars.cssId.quizListEmbedFrameCls).html(
                                '<script type="text/javascript" src="//cdn.playbuzz.com/widget/feed.js"></script>' +
                                '<div class="pb_feed" data-embed-by="' + embedBy + '"\n' +
                                'data-item="' + game + '" data-recommend="false" data-game-info="false" ' +
                                'data-comments="false" data-shares="false" ></div>');

                            const quizWaitingInterval = setInterval(() => {

                                $(view.publicVars.cssId.quizListEmbedId + id).css({
                                    overflow: 'hidden'
                                });

                                $(view.publicVars.cssId.quizListEmbedId + id + ' ' + view.publicVars.cssId.quizListEmbedFrameCls).css({
                                    display: 'block', opacity: 0, visibility: 'hidden', overflow: 'hidden'
                                });

                                const quizHeight = $(view.publicVars.cssId.quizListEmbedId + id + ' '
                                    + view.publicVars.cssId.quizListEmbedFrameCls).outerHeight();

                                if(quizHeight > 50) {

                                    clearInterval(quizWaitingInterval);

                                    $(view.publicVars.cssId.quizLoaderId + id).transit({ opacity: 0 }, 300, () => {
                                        $(view.publicVars.cssId.quizLoaderId + id).removeAttr('style');
                                    });

                                    const modifier = - parseInt((headerHeight + submenuHeight)) + 2;

                                    //jump.jumpTo(view.publicVars.cssId.quizListEmbedId + id, { modifier: modifier + 'px' });

                                    $(view.publicVars.cssId.quizListEmbedId + id).removeAttr('style');
                                    $(view.publicVars.cssId.quizListEmbedId + id).css({ padding: '10px', visibility: 'visible', display: 'block'});

                                    $(view.publicVars.cssId.quizListEmbedId + id + ' '
                                        + view.publicVars.cssId.quizListEmbedFrameCls).removeAttr('style');

                                    $(view.publicVars.cssId.quizListEmbedId + id + ' '
                                        + view.publicVars.cssId.quizListEmbedFrameCls).css({ opacity: 0 });

                                    $(view.publicVars.cssId.quizListEmbedId + id + ' '
                                        + view.publicVars.cssId.quizListEmbedFrameCls).transit({ opacity: 1}, 300, () => {
                                    });

                                    view.privateVars.anim = 0;

                                }

                            }, 100);

                        }, {
                            modifier: - parseInt(headerHeight + submenuHeight)
                        });
                    });

                    // $(view.publicVars.cssId.quizListEmbedId + id).html('<script type="text/javascript" src="//cdn.playbuzz.com/widget/feed.js"></script>' +
                    //     '<div class="pb_feed" data-embed-by="' + embedBy + '"\n' +
                    //     'data-item="' + game + '" data-recommend="false" data-game-info="false" data-comments="false" data-shares="false" ></div>');
                    //
                    // $(view.publicVars.cssId.quizListEmbedId + id).css({ display: 'block', visibility: 'visible'});
                    // $(view.publicVars.cssId.quizListEmbedId + id).transit({ opacity: 1, padding: '10px' });
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowCharacter', view.methods.actionShowCharacter);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
